import React, { FC, useState } from 'react';
import Image from 'components/image/Image';
import Button from 'components/Button/Index';
import { ICompanylogo } from 'core/interface/companyLogo';
import Activation from '../Index';
import ImagePicker from 'components/imagePicker';

import './index.scss';

interface ActivationAvatarLogoProps extends ICompanylogo {
  currentStep: number;
  totalSteps: number;
}

const ActivationAvatarLogo: FC<ActivationAvatarLogoProps> = ({
  t,
  onSubmit,
  setCompanyData,
  onBack,
  currentStep,
  totalSteps
}): JSX.Element => {
  const [avatar, setAvatar] = useState<File | null>(null);

  const handleLogoSave = async (): Promise<void> => {
    if (avatar) {
      setCompanyData((prev: any) => ({
        ...prev,
        avatar
      }));
      onSubmit();
    }
  };

  return (
    <Activation
      title={t('Add your avatar')}
      currentStep={currentStep}
      totalSteps={totalSteps}
    >
      <div className="av">
        <div className="av__content">
          <ImagePicker
            setLogo={(file: File) => setAvatar(file)}
            logo={avatar}
            max={1}
          />
          <div className="av__content__buttons">
            <Button
              onClick={onBack}
              t={t}
              title="Back"
              className="av__content__buttons-back"
            />
            <Button
              onClick={handleLogoSave}
              t={t}
              title="Next"
              className={`av__content__buttons-next ${
                !avatar ? 'deactive' : ''
              }`}
              disabled={!avatar}
            />
          </div>
        </div>
      </div>
    </Activation>
  );
};

export default ActivationAvatarLogo;
